/*
  MS Parts - Sticky Kaufleiste auf dem Handy (Claude, 02.10.2026)

  Unten eine schmale Leiste mit Produktname, aktuellem Preis und Kaufbutton.
  Sie klickt den echten Button, es wird keine eigene Kauflogik gebaut.
  Sie verschwindet, sobald der echte Button im Bild ist.
  Nur unter 760px Breite, nur auf Produktseiten.

  08.10.2026 (Bugtest live): Die Fahrzeug-Leiste #msp-avb lag auf derselben
  Hoehe am unteren Rand, die Kaufleiste hat sie verdeckt. Jetzt werden beide
  gestapelt: Kaufleiste zuunterst, Fahrzeug-Leiste direkt darueber, unterer
  Innenabstand des Body gleich der Summe. Ein- und Ausblenden laeuft ueber
  eine Inline-Transformation statt ueber eine CSS-Klasse, weil die Klasse im
  Live-Theme nicht zuverlaessig gegriffen hat.
*/
(function () {
  'use strict';
  if (window.__mspStickyAtc) return;
  window.__mspStickyAtc = 1;

  function init() {
    if (window.innerWidth >= 760) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var real = form.querySelector('[type="submit"], button[name="add"], [data-product-atc]');
    if (!real) return;

    var titleEl = document.querySelector('h1');
    var title = titleEl ? titleEl.textContent.trim() : '';

    var css = document.createElement('style');
    css.appendChild(document.createTextNode([
      '.msp-atc{position:fixed;left:0;right:0;bottom:0;z-index:9999;display:flex;align-items:center;gap:12px;',
      'padding:10px 14px calc(10px + env(safe-area-inset-bottom));background:rgba(255,255,255,.97);',
      'border-top:1px solid #e4e8ec;box-shadow:0 -6px 20px rgba(10,15,20,.08);',
      'transition:transform .25s ease}',
      '.msp-atc .t{flex:1;min-width:0}',
      '.msp-atc .n{display:block;font-size:11.5px;line-height:1.2;color:#6f7781;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '.msp-atc .p{display:block;font-size:15px;font-weight:700;color:#0e1114;margin-top:2px}',
      '.msp-atc button{flex:0 0 auto;background:#0b9fff;color:#fff;border:0;border-radius:9px;',
      'padding:13px 18px;font-size:15px;font-weight:700;line-height:1;cursor:pointer}',
      '.msp-atc button:active{background:#0a8ce0}',
      '#msp-avb{transition:bottom .25s ease}'
    ].join('')));
    document.head.appendChild(css);

    var bar = document.createElement('div');
    bar.className = 'msp-atc';
    bar.style.transform = 'translateY(130%)';
    bar.innerHTML = '<div class="t"><span class="n"></span><span class="p"></span></div>';
    bar.querySelector('.n').textContent = title;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'In den Warenkorb';
    bar.appendChild(btn);
    document.body.appendChild(bar);

    var shown = false;

    function stack() {
      var avb = document.getElementById('msp-avb');
      var atcH = shown ? Math.round(bar.getBoundingClientRect().height) : 0;
      var avbH = 0;
      if (avb) {
        avb.style.bottom = atcH + 'px';
        avbH = Math.round(avb.getBoundingClientRect().height);
      }
      var pad = atcH + avbH + 8;
      if (pad < 78) pad = 78;
      document.body.style.paddingBottom = pad + 'px';
    }

    function show(on) {
      shown = !!on;
      bar.style.transform = shown ? 'translateY(0)' : 'translateY(130%)';
      setTimeout(stack, 60);
    }

    function price() {
      var nodes = document.querySelectorAll('[class*="price"]');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].children.length > 3) continue;
        var m = (nodes[i].textContent || '').match(/CHF\s?[\d'’.,]+/);
        if (m && m[0].replace(/[^\d]/g, '').replace(/^0+/, '') !== '') return m[0];
      }
      return '';
    }
    function setPrice() {
      var p = price();
      if (p) bar.querySelector('.p').textContent = p;
    }
    setPrice();

    btn.addEventListener('click', function () {
      setPrice();
      try { real.click(); } catch (e) {}
    });
    document.addEventListener('change', function () { setTimeout(setPrice, 200); });
    window.addEventListener('resize', stack);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        if (!e) return;
        show(!e.isIntersecting);
      }, { threshold: 0, rootMargin: '-70px 0px -90px 0px' });
      io.observe(real);
    } else {
      show(true);
    }

    stack();
    setTimeout(stack, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
